export function KnowledgeNetworkFooter() {
  return (
    <footer className="mt-auto border-t border-[#a2a9b1] bg-[#f8f9fa]">
      <div className="max-w-[960px] mx-auto px-4 py-8 font-sans">
        <div className="text-center mb-6">
          <h3 className="text-lg font-serif font-semibold text-[#202122]">
            Mercava Knowledge
          </h3>
          <p className="text-sm text-[#54595d] mt-1">
            The Chariot Vision &amp; Merkavah Mysticism
          </p>
        </div>
        <div className="mt-4 border-t border-[#eaecf0] pt-4">
          <p className="text-[10px] uppercase tracking-wider text-[#72777d] text-center mb-2">
            Sources Referenced
          </p>
          <div className="flex flex-wrap justify-center gap-2 text-[10px] text-[#72777d]">
            <span>Ezekiel</span>
            <span>|</span>
            <span>Heichalot Literature</span>
            <span>|</span>
            <span>Zohar</span>
            <span>|</span>
            <span>Sefer Yetzirah</span>
          </div>
        </div>
        <div className="mt-6 text-center text-xs text-[#72777d] space-y-2">
          <p>Educational resource drawing from authentic primary sources.</p>
          <p className="mt-4 text-[#54595d]">
            Part of the{' '}
            <a href="https://globalknowledgegraph.com" className="text-[#3366cc] hover:underline">
              Global Knowledge Graph Network
            </a>
          </p>
          <p className="mt-3">&copy; {new Date().getFullYear()} Mercava Knowledge. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
